module.exports = __webpack_public_path__ + "img/img.9b79cb1a.jpg";